function edgeTargetKey(edge) {
    const t = edge?.target || {};
    const id = t.id || t.number || t.eeiNumber || t.icrNumber || t.gapNumber;
    return `${t.type || edge?.toType || '?'}:${id || '?'}`;
}

function buildProposedIcrEdge(gap) {
    if (!gap?.icrId && !gap?.icrNumber) return null;
    const pending = !gap.icrNumber;
    const question = gap.icrQuestion || gap.icrTitle || gap.text;
    const statusNote = pending || gap.workflowStatus === 'Pending Approval'
        ? 'Proposed ICR from this gap · Pending Approval'
        : 'Proposed ICR from this gap';
    return {
        id: `gap-proposed-icr-${gap.id || gap.gapNumber}`,
        source: 'proposed',
        reviewStatus: 'confirmed',
        displayRelation: 'FULL',
        relation: 'EQUIVALENT_TO',
        target: {
            type: 'ICR',
            id: gap.icrId,
            number: gap.icrNumber || undefined,
            icrNumber: gap.icrNumber || undefined,
            question,
            title: gap.icrTitle || question,
            text: question,
        },
        comment: statusNote,
    };
}

function buildPromotedEeiEdge(gap) {
    if (!gap?.eeiId && !gap?.eeiNumber) return null;
    return {
        id: `gap-promoted-eei-${gap.id || gap.gapNumber}`,
        source: 'proposed',
        reviewStatus: 'confirmed',
        displayRelation: 'FULL',
        relation: 'EQUIVALENT_TO',
        target: {
            type: 'EEI',
            id: gap.eeiId,
            number: gap.eeiNumber,
            eeiNumber: gap.eeiNumber,
            text: gap.text,
        },
        comment: 'EEI created from this gap',
    };
}

export function gapLinkToSimilarityEdge(link, gap) {
    const t = link.target || {};
    return {
        id: link.id,
        fromType: 'GAP',
        fromId: gap?.id,
        toType: link.targetType,
        toId: t.id,
        relation: 'EQUIVALENT_TO',
        displayRelation: 'FULL',
        lineStyle: 'solid',
        source: 'manual',
        reviewStatus: 'confirmed',
        gapLink: true,
        target: {
            ...t,
            type: link.targetType || t.type,
        },
    };
}

/** Merge proposed ICR/EEI, manual gap links, and machine similarity into one Similar list. */
export function buildGapSimilarEdges(gap) {
    const related = Array.isArray(gap?.related) ? gap.related : [];
    const links = Array.isArray(gap?.links) ? gap.links : [];
    const seen = new Set();
    const out = [];

    const push = (edge) => {
        if (!edge) return;
        const key = edgeTargetKey(edge);
        if (seen.has(key)) return;
        seen.add(key);
        out.push(edge);
    };

    push(buildProposedIcrEdge(gap));
    push(buildPromotedEeiEdge(gap));
    for (const link of links) {
        push(gapLinkToSimilarityEdge(link, gap));
    }
    for (const edge of related) {
        push(edge);
    }
    return out;
}
